import { z } from "zod";

/**
 * Schema do formulário de solicitação de reabertura de venda.
 */
export const reopenRequestSchema = z.object({
  recipientToken: z
    .string({ required_error: "Selecione um destinatário" })
    .trim()
    .min(1, "Selecione um destinatário"),
  requesterReason: z.string().trim().optional(),
});
